import { JsonapiEntity, attribute, entity, meta } from 'jsonapi-transformers';

@entity({ type: 'tags' })
export class Tag extends JsonapiEntity<Tag> {
  @attribute() title: string;
  @attribute({ name: 'is_active' }) isActive: boolean;
  @meta({ name: 'related_list_items' }) relatedListItems: number;
}
